export default {
	buttons: {
		auth: {
			login: "Login",
			create_account: "Create account",
		},
		general: {
			save: "Save",
			add: "Add",
			edit: "Edit",
			delete: "Delete",
			grid: "Grid",
			list: "List",
			devices: "Devices",
			patients: "Patients",
			manage: "Manage",
			history: "History",
			by_date: "By date",
			actives: "Actives",
			all: "All",
			upcoming: "Upcoming",
			calendar: "Calendar",
			by_day: "By day",
			detach: "Detach",
			attach: "Attach",
			submit: "Submit",
			resume: "Resume",
			response: "Response",
			configs: "Configurations",
			send: "Send",
			report: "Report",
			attachment: "Attachment",
			see_all: "See All"
		},
		actions: {
			get_more: "Get more",
			add_group: "Add group",
			add_device: "Add device",
			add_patient: "Add patient",
			edit_group: "Edit group",
			edit_device: "Edit device",
			edit_patient: "Edit patient",
			view_all: "View all",
			view_watch: "View watch",
			clear_alerts: "Clear alerts",
			// user profile
			update_name: "Update name",
			update_email: "Update email",
			update_password: "Update password",
			update_picture: "Update picture",
			// watch profile
			edit_profile: "Edit profile",
			add_contact: "Add contact",
			edit_contact: "Edit contact",
			add_disease: "Add disease",
			edit_disease: "Add disease",
			add_relation: "Add relation",
			add_relation_contact: "Add relation contact",
			edit_relation: "Edit relation",
			edit_relation_contact: "Edit relation contact",
			add_number: "Add number",
			edit_number: "Edit number",
			add_insurance: "Add insurance",
			edit_insurance: "Edit insurance",
			// pillbox
			add_pill: "Add pill",
			// appointments
			add_appointment: "Add appointment",
			// health reports
			add_healthreport: "Add report",
			edit_healthreport: "Edit report",
			delete_healthreport: "Delete report",
			// medical documents
			add_medicaldocument: "Add document",
			edit_medicaldocument: "Edit document",
			view_report: "View report",
			// readings
			add_parameters: "Add Parameters",
			edit_parameters: "Edit Parameters",
			delete_parameters: "Delete Parameters",
		}
	}
}



// WEBPACK FOOTER //
// ./src/i18n/buttons/buttons_en-gb.js